import Gateway from '@/utils/Gateway';
import { isPrivate } from 'src/config/private';

// 获取代开发应用安装状态
export default function getAuthorizeAppResult() {
    let QrcodeParams = '';
    QrcodeParams = 'address_book';
    return Gateway.get('/v1/basic/corp/wework/authorizeAppResult', { template: QrcodeParams }).then((data) => {
        const { status, step } = data || {};
        return {
            // hasInstall: status === 1
            hasInstall: isPrivate ? status == 1 : status == step.length,
            step,
            status,
        };
    });
}
